import { render, staticRenderFns } from "./EmployeeBirthDayField.vue?vue&type=template&id=654ca743&"
import script from "./EmployeeBirthDayField.vue?vue&type=script&lang=js&"
export * from "./EmployeeBirthDayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('654ca743')) {
      api.createRecord('654ca743', component.options)
    } else {
      api.reload('654ca743', component.options)
    }
    module.hot.accept("./EmployeeBirthDayField.vue?vue&type=template&id=654ca743&", function () {
      api.rerender('654ca743', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeBirthDayField.vue"
export default component.exports